var React = require('react');

function XInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1101_71)","key":0},React.createElement("path",{"d":"M10.1173 7.35652L16.4459 0H14.9463L9.45111 6.38757L5.06215 0H0L6.63697 9.65913L0 17.3736H1.49977L7.30279 10.6281L11.9379 17.3736H17L10.1169 7.35652H10.1173ZM8.06317 9.74423L7.39071 8.7824L2.04016 1.129H4.34371L8.66167 7.30554L9.33413 8.26737L14.947 16.2959H12.6434L8.06317 9.7446V9.74423Z","fill":"#76B459"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1101_71"},React.createElement("rect",{"width":"17","height":"17.3825","fill":"white"})))]);
}

XInline.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none"};

module.exports = XInline;

XInline.default = XInline;
